<template>
  <form @submit.prevent="submit" class="mx-auto space-y-4 text-left">
    <div>
      <div class="bg-white rounded flex flex-col py-1.5 px-2 ">
        <label for="name" class="text-sm text-gray-500">Name <span class="text-red-500">(Required)</span></label>
        <input v-model="fields.name" id="name" type="text" class="text-gray-600 bg-transparent focus:outline-none" />
      </div>
      <div v-if="errors && errors.name" class="text-gray-200">{{ errors.name[0] }}</div>
    </div>
    <div>
      <div class="bg-white rounded flex flex-col py-1.5 px-2 ">
        <label for="email" class="text-sm text-gray-500">E-Mail <span class="text-red-500">(Required)</span></label>
        <input v-model="fields.email" id="email" type="email" class="text-gray-600 bg-transparent focus:outline-none" />
      </div>
      <div v-if="errors && errors.email" class="text-gray-200">{{ errors.email[0] }}</div>
    </div>
    <div>
      <div class="bg-white rounded flex flex-col py-1.5 px-2">
        <label for="contact_number" class="text-sm text-gray-500">Contact Number <span
            class="text-red-500">(Required)</span></label>
        <input v-model="fields.contact" id="contact_number" type="tel"
          class="text-gray-600 bg-transparent focus:outline-none" />
      </div>
      <div v-if="errors && errors.contact" class="text-gray-200">{{ errors.contact[0] }}</div>
    </div>
    <div>
      <div class="bg-white rounded flex flex-col py-1.5 px-2">
        <label for="message" class="text-sm text-gray-500">Message</label>
        <textarea v-model="fields.message" id="message" rows="4" type="text"
          class="h-auto p-0 px-0 m-0 font-sans text-base text-gray-600 bg-transparent border-0 focus:outline-none"></textarea>
      </div>
      <!-- <div v-if="errors && errors.name" class="text-red-900">{{ errors.name[0] }}</div> -->
    </div>
    <div>
      <div class="">
        <div recaptcha-el></div>
        <div class="text-red-900">{{ recaptchaError }}</div>
      </div>
      <br>
      <button ref="btnSubmit" v-text="busy ? 'Submitting...' : 'Submit Enquiry'" type="submit"
        class="w-full py-4 text-xl font-semibold uppercase transition bg-white border-none rounded text-blue-1 opacity-95 hover:opacity-100 disabled:cursor-wait disabled:opacity-50"></button>

    </div>
  </form>
</template>

<script>
import hapiMixins from 'hapiform-with-recaptcha';

export default {
  mixins: [hapiMixins],
  // components: { InputError },
  data() {
    return {
      fields: {
        contact: '+60'
      },
      endpoint: "https://hapiform.sg/api/df2a35c5-5daf-4ad8-9d2b-bc079fba62fd",
      redirectTo: "/thank-you",
      recaptchaDisabled: false
    };
  },
  methods: {
    addFormDataToDataLayer() {
      const name = this.$data.fields.name;
      const email = this.$data.fields.email;
      const contact = this.$data.fields.contact;

      if (name && email && contact) {
        // verify required fields

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'form_submission',
          'enhanced_conversion_data': {
            name: this.$data.fields.name,
            email: this.$data.fields.email,
            contact: this.$data.fields.contact,
          }
        });
      }
    }
  },
  mounted() {
    this.$refs.btnSubmit.addEventListener('click', this.addFormDataToDataLayer)
  },
  beforeDestroy() {
    this.$refs.btnSubmit.removeEventListener('click', this.addFormDataToDataLayer)
  }
};
</script>
